export default "__VITE_ASSET__COp_4PGJ__"